const currentClass = 'download-item__button--current';

document.addEventListener('DOMContentLoaded', function () {
    const dropdownNodes = document.querySelectorAll('.download-item__dropdown');

    dropdownNodes.forEach(function (dropdownNode) {
        const linkNode = dropdownNode.closest('.download-item');
        const languagesNode = linkNode.querySelector('.download-item__languages');
        const currentButtonNode = dropdownNode.querySelector('.download-item__dropdown--current-button');
        const buttons = dropdownNode.querySelectorAll('.download-item__button');
        let currentNode = dropdownNode.querySelector(`.${currentClass}`);

        if (!currentNode && buttons.length > 0) {
            currentNode = buttons[0];
            currentNode.classList.add(currentClass);
        }

        currentButtonNode.innerHTML = currentNode.innerHTML;

        languagesNode.addEventListener('click', function (e) {
            dropdownNode.classList.toggle('open');
            languagesNode.classList.toggle('open');
        });

        updateElements(currentNode, linkNode, currentNode);

        if (linkNode) {
            buttons.forEach(function (button) {
                button.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    if (button !== currentNode) {
                        if (currentNode) {
                            currentNode.classList.remove(currentClass);
                        }

                        currentNode = button;
                        currentNode.classList.add(currentClass);

                        updateElements(button, linkNode, currentNode);
                        currentButtonNode.innerHTML = button.innerHTML;
                        dropdownNode.classList.remove('open');
                        languagesNode.classList.remove('open');
                    }
                });
            });
        }
    });
});

function updateElements(button, linkNode, currentNode) {
    const data = button.dataset;
    const sizeNode = linkNode.querySelector('.download-item-file__info--size');
    const extensionNode = linkNode.querySelector('.download-item-file__info--extension');
    const fileLink = linkNode.querySelector('.download-item-file');

    currentNode.innerHTML = button.innerHTML;

    fileLink.href = button.href;
    fileLink.dataset.language = data.language;
    sizeNode.innerText = data.filesize;
    extensionNode.innerText = data.fileextension;
}

document.addEventListener('DOMContentLoaded', function () {
    const detailsElements = document.querySelectorAll('.neos-backend details');

    detailsElements.forEach(function (element) {
        element.addEventListener('click', function (event) {
            event.preventDefault();
        });
    });
});
